export default __webpack_public_path__ + "static/media/jasmine_and_ian-0676_tn.3385c121.jpg";